module.exports = __webpack_public_path__ + "img/covhelp.eb67a7db.webp";